
import React from 'react';
import { Switch } from '@/components/ui/switch';

interface ProductSummaryToggleProps {
  showSummary: boolean;
  setShowSummary: (show: boolean) => void;
}

const ProductSummaryToggle = ({ showSummary, setShowSummary }: ProductSummaryToggleProps) => {
  return (
    <div className="bg-white dark:bg-[#1a1a2e] border border-gray-200 dark:border-gray-800 rounded-lg shadow-sm">
      <div className="p-4 sm:p-6">
        <div className="flex items-center justify-between">
          <h2 className="text-lg font-medium text-gray-800 dark:text-white">Bref aperçu du produit</h2>
          <Switch
            checked={showSummary}
            onCheckedChange={setShowSummary}
          />
        </div>
      </div>
    </div>
  );
};

export default ProductSummaryToggle;
